<div class="dlg-container" data-cy="mimics-new-mimic-modal">
    <div class="header">
        <h3 class="title">{{ 'mimic-drawing.new-mimic-title' | translate }}</h3>
        <span class="vessel-name">{{ data.vessel.name }}</span>
    </div>
    <div class="main">
        <div class="content">
            <app-input-with-error
                [inputValue]="name"
                [legend]="'mimic-drawing.mimic-name'"
                [propertyName]="'name'"
                [validatorFunction]="validatorFunction()"
                [otherValidationErrors]="titleError"
                (onInputUpdated)="nameChange($event)"
                maxlength="40">
            </app-input-with-error>
            <div class="background-color input-container">
                <h5 class="sub-title">
                    {{ 'mimic-drawing.mimic-bgcolor' | translate }}
                </h5>
                <app-editor-input-color
                    [light]="true"
                    colorBoxWidth="30%"
                    [value]="bkcolor"
                    (onInputChange)="backgroundColorChange($event)">
                </app-editor-input-color>
            </div>
            <div class="grid input-container">
                <div class="sub-title-container">
                    <h5 class="sub-title">
                        {{ 'mimic-drawing.mimic-grid' | translate }}
                    </h5>
                    <app-toggle-switch
                        name="dialogNewMimicGrid"
                        [value]="allowGrid"
                        (onChange)="allowGridChange($event)">
                    </app-toggle-switch>
                </div>
                <div class="grid-input">
                    <app-editor-input-text
                        [readonly]="!allowGrid"
                        name="gridSpacing"
                        label="Grid spacing"
                        [value]="grid"
                        [light]="true"
                        type="number"
                        [maxValue]="GRID_MAX"
                        [minValue]="GRID_MIN"
                        [focusEffect]="true"
                        (onInputChange)="gridChange($event)">
                    </app-editor-input-text>
                    <button class="grid-spacing-button" (click)="allowGrid ? gridInputButtonClick('minus') : null">
                        <mat-icon svgIcon="minus"></mat-icon>
                    </button>
                    <button class="grid-spacing-button" (click)="allowGrid ? gridInputButtonClick('plus') : null">
                        <mat-icon svgIcon="plus"></mat-icon>
                    </button>
                </div>
                <app-editor-input-color
                    [light]="true"
                    colorBoxWidth="30%"
                    value="#bccff2"
                    (onInputChange)="colorChange($event)">
                </app-editor-input-color>
            </div>
        </div>
        <div class="side">
            <app-button
                text="mimic.create.dialog.button.create"
                [disable]="!name || titleError"
                [size]="BUTTON_SMALL_SIZE"
                (onClick)="saveButtonClick()"></app-button>
            <app-button
                text="mimic.create.dialog.button.cancel"
                [size]="BUTTON_SMALL_SIZE"
                [variant]="BUTTON_OUTLINE"
                customFontColor="#1f6873"
                customBorderColor="#1f6873"
                (onClick)="cancelButtonClick()"></app-button>
            <app-button
                text="mimic.create.dialog.button.upload-pdf"
                [size]="BUTTON_SMALL_SIZE"
                [variant]="BUTTON_OUTLINE"
                customFontColor="#1f6873"
                customBorderColor="#1f6873"
                (onClick)="onImportPDF()"></app-button>
            <input
                #pdfFile
                type="file"
                id="viewPDFUpload"
                style="display: none"
                (click)="$event.stopPropagation()"
                (change)="onSetPDF($event)"
                accept="application/pdf" />
        </div>
    </div>
</div>

<ng-container *ngIf="loadingPDFViews">
    <app-loading-spinner class="spinner-component"></app-loading-spinner
></ng-container>
